import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VAvatar,{attrs:{"width":_vm.width,"height":_vm.height,"min-width":_vm.minWidth,"min-height":_vm.minHeight}},[_c(VImg,{style:(_vm.styleObject),attrs:{"contain":"","src":_vm.imageUrl}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }